import { render, staticRenderFns } from "./GoodsAdd.html?vue&type=template&id=6430f70a&scoped=true&"
import script from "./GoodsAdd.vue?vue&type=script&lang=js&"
export * from "./GoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAdd.vue?vue&type=style&index=0&id=6430f70a&scoped=true&lang=css&"
import style1 from "./GoodsAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6430f70a",
  null
  
)

export default component.exports